import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { showAllProducts, clearSearch } from "../../../store/slices/productsSlice";
import { showLandpageView } from "../../../store/slices/landpageManagerSlice";

/**
 * Componente de logo clicável responsivo.
 * Ao clicar, limpa a busca e exibe todos os produtos (funciona como "Home").
 * Tamanhos adaptativos: mobile (80x38px) e desktop (120x65px).
 * 
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.src="/vika_icon.png"] - Caminho da imagem do logo
 * @param {boolean} [props.isMobile=false] - Se está em modo mobile
 * @returns {JSX.Element} Logo responsivo com ação de navegação
 */
function Logo({ src = "/vika_icon.png", isMobile = false }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(showAllProducts());
    dispatch(clearSearch());
    dispatch(showLandpageView());
  };

  return (
    <Box
      component="img"
      src={src}
      alt="Logo da aplicação"
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        background: 'transparent',
        ...(isMobile ? {
          mt: 1,
          width: 90,
          height: 37,
          ml: 0,
          pl: 0,
          flexShrink: 0,
        } : {
          width: 160,
          height: 81,
          pl: 0,
          py: 1,
          mt: 1,
          ml: '38px',
          flexShrink: 0,
        })
      }}
    />
  );
}

export default Logo;